/* global $, gtag */

import { Controller } from 'stimulus';

class SignController extends Controller {
  onSubmit(event) {
    event.preventDefault();

    const data = new FormData(this.element);

    this.removeErrors();
    this.markLoading();

    $.ajax({
      url: this.element.action,
      type: 'POST',
      processData: false,
      contentType: false,
      data,
      success: () => {
        this.showSuccess();
        this.markReady();
      },
      error: ({ responseJSON }) => {
        if (
          typeof responseJSON !== 'undefined'
          && typeof responseJSON.errors !== 'undefined'
        ) {
          this.outputErrors(responseJSON.errors);
        }

        this.markReady();
      },
    });
  }

  showSuccess() {
    this.signStateTarget.setAttribute('hidden', 'hidden');
    this.successStateTarget.removeAttribute('hidden');

    requestAnimationFrame(() => {
      this.element.classList.add('is-success');
    });

    if (typeof gtag !== 'undefined') {
      gtag('event', 'sign', {
        event_category: 'Signature',
        event_label: window.location.href,
        value: 0,
      });
    }
  }

  markLoading() {
    this.submitTarget.setAttribute('disabled', 'disabled');
  }

  markReady() {
    this.submitTarget.removeAttribute('disabled');
  }

  removeErrors() {
    this.errorContainerTarget.innerHTML = '';
    this.errorContainerTarget.setAttribute('hidden', 'hidden');
  }

  outputErrors(errors) {
    const errorMessages = Object.keys(errors).map((errorKey) => `
      <div>${errors[errorKey]}</div>
    `);

    this.errorContainerTarget.innerHTML = errorMessages.join('');
    this.errorContainerTarget.removeAttribute('hidden');
  }
}

SignController.targets = [
  'signState',
  'successState',
  'errorContainer',
  'submit',
];

export default SignController;
